import _ from 'lodash';
import path from 'path-browserify';

export default _import => (id, file) => {
  const mod = {
    feature: file.feature,
    exports: {}
  };

  const fn = new Function('module', 'exports', 'require', file.es6);
  fn(mod, mod.exports, dep => {
    const absoluteId =
      dep.charAt(0) === '.' ? path.resolve('/' + path.dirname(id), dep).slice(1) : dep;
    return _import(absoluteId, id);
  });

  return mod.exports.default
    ? Object.assign(mod.exports.default, _.omit(mod.exports, ['default']))
    : mod.exports;
};
